import type { Ctx } from "../../types";
import { FormAction, invalidate, setQueryParams } from "gg-wf-scripts";
import { invokeApi, parse } from "../_helpers";
import { job_opening_schema } from "./_schema";

export const update_job_opening: FormAction<Ctx> = async (
  { sb },
  formData,
  params
) => {
  const job_opening_id = params.get("id");
  if (!job_opening_id) return { ok: false, error: "Missing id in URL" };

  const parsed = parse(job_opening_schema, formData);
  if (!parsed.ok) return parsed;

  const { school, draft, custom_time, ...rest } = parsed.data;
  const body = {
    ...rest,
    school_id: school,
    job_status: draft ? "draft" : "open",
    ...(custom_time ? { shift_type: "custom" as const } : {}),
  };

  const result = await invokeApi(sb, `api/jobs/${job_opening_id}`, {
    method: "PUT",
    body,
  });
  if (!result.ok) return result;
  invalidate("jobs");
  setQueryParams([{ key: "modal", value: "view" }]);
  return result;
};
